import { Component, OnInit, ViewChild, EventEmitter } from "@angular/core";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";
import { CclMessageService } from "certain-common-library";

@Component({
    selector: "theme-config",
    templateUrl: "./theme-config.view.html",
    providers: []
})
export class ThemeConfigView implements OnInit {
    private subscription: any;

    constructor(
        public sharedService: SharedService,
        private messageService: CclMessageService
    ) {}

    ngOnInit() {}
}
